export const partnerId = "5ffef80c52e22826bdf9211f"
